import React from 'react';
import css from './ProfilePage.module.css';
import { FormattedMessage } from 'react-intl';

const CompanyInfoSection = ({ publicData }) => {
  const { brandDescription, brandName, companyName } = publicData || {};

  return (
    <div className={css.infoBlock}>
      <h2>
        <FormattedMessage id="ProfilePage.companyInfoSectionHeading" />
      </h2>

      <div className={css.serviceList}>
        {companyName && (
          <div className={css.service}>
            <strong>
              <FormattedMessage id="ProfilePage.companyNameLabel" />:
            </strong>
            {companyName}
          </div>
        )}

        {brandName && (
          <div className={css.service}>
            <strong>
              <FormattedMessage id="ProfilePage.brandNameLabel" />:
            </strong>
            {brandName}
          </div>
        )}

        {brandDescription && (
          <div className={css.service}>
            <strong>
              <FormattedMessage id="ProfilePage.brandDescriptionLabel" />:
            </strong>
            {brandDescription}
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanyInfoSection;
